module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.formState == 'NEW') ? _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.vincularTag.apply(null, arguments)
      }
    }
  }, [_c('div', {
    class: {
      'has-error': _vm.errors.has('serialNumber')
    }
  }, [_c('div', {
    staticClass: "form-tag-activate"
  }, [_c('b', [_vm._v("TAG Número")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.serialNumber),
      expression: "serialNumber"
    }],
    staticClass: "form-control input-tag-number",
    attrs: {
      "data-vv-rules": "required|numeric",
      "type": "text",
      "name": "serialNumber",
      "placeholder": "0000000000",
      "id": _vm.vehicle
    },
    domProps: {
      "value": (_vm.serialNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.serialNumber = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-activate",
    attrs: {
      "type": "submit",
      "name": "button"
    }
  }, [_vm._v("\n      Ativar\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "help-block"
  }, [_vm._v("\n    " + _vm._s(_vm.errors.first('serialNumber')) + "\n  ")])]) : (_vm.formState == 'OLD') ? _c('form', [_c('div', {
    class: {
      'has-error': _vm.errors.has('serialNumber')
    }
  }, [_c('div', {
    staticClass: "form-tag-activate"
  }, [_c('b', [_vm._v("TAG Número")]), _vm._v(" "), _c('p', {
    staticClass: "cell-activated-tag"
  }, [_vm._v(_vm._s(_vm.serialNumber))])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-activate-tag",
    attrs: {
      "type": "button",
      "name": "button"
    }
  }, [_vm._v("\n      Ativo\n    ")])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-85aa9308!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/account/ativar-tag/ativar-tag-item.vue
// module id = 2188
// module chunks = 1